.root {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}

.heading {
  font-size: var(--type-caption);
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--color-text-muted);
}

.nativeInput {
  display: none;
}

.addButton {
  display: flex;
  align-items: center;
  gap: var(--space-10);
  width: fit-content;
  padding: clamp(var(--space-8), 1vw, var(--space-12))
    clamp(var(--space-10), 1.2vw, var(--space-14));
  font-family: var(--font-body);
  font-size: 1rem;
  line-height: 1.5;
  text-align: left;
  color: var(--color-text-muted);
  background: transparent;
  border: 1px solid var(--color-control-border);
  border-radius: var(--radius-small);
  cursor: pointer;
  transition:
    border-color var(--motion-fast) ease,
    color var(--motion-fast) ease;

  svg {
    flex-shrink: 0;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover:not(:disabled) {
      color: var(--color-text);
      border-color: var(--color-primary);
    }
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
}

.hint {
  font-size: var(--type-caption);
  color: var(--color-text-muted);
}

.errorText {
  font-size: var(--type-caption);
  color: var(--color-danger);
}

.list {
  margin: 0;
  padding: 0;
  list-style: none;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-small);
}

.item {
  display: flex;
  align-items: center;
  gap: var(--space-8);
  min-width: 0;
  padding: var(--space-2) var(--space-4) var(--space-2)
    clamp(var(--space-10), 1.2vw, var(--space-14));
  font-size: var(--type-caption);
  color: var(--color-text);

  & + & {
    border-top: 1px solid var(--color-border);
  }
}

.kind {
  display: flex;
  flex-shrink: 0;
  color: var(--color-text-muted);
}

.name {
  display: flex;
  flex: 1;
  min-width: 0;
  white-space: nowrap;
}

.nameStart {
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.size {
  flex-shrink: 0;
  font-size: var(--type-caption);
  color: var(--color-text-muted);
}

.remove {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  color: var(--color-text-muted);
  background: transparent;
  border: none;
  border-radius: var(--radius-small);
  cursor: pointer;
  transition: color var(--motion-fast) ease;

  @media (hover: hover) and (pointer: fine) {
    &:hover:not(:disabled) {
      color: var(--color-text);
    }
  }
}
